// extracted by mini-css-extract-plugin
export default {"container":"DiseaseKnowledgeDialog_container__y8QlX","closeButton":"DiseaseKnowledgeDialog_closeButton__SK6KZ"};